/**
 * One-pan recipes - Quick prep, one pan to wash
 * ~20 recipes for minimal cleanup cooking
 */

const ONE_PAN_RECIPES = [
  {
    id: 'scrambled-eggs',
    name: 'Scrambled Eggs',
    effort: 'one-pan',
    needs: ['egg', 'butter'],
    optional: ['cheese', 'herbs', 'toast'],
    description: 'Classic comfort food, 5 minutes',
    tips: 'Low heat and stir constantly for creamy eggs'
  },
  {
    id: 'omelette',
    name: 'Omelette',
    effort: 'one-pan',
    needs: ['egg', 'butter'],
    optional: ['cheese', 'ham', 'mushroom', 'onion'],
    description: 'Filled eggs, feels fancy',
    tips: 'Tilt pan to spread uncooked egg'
  },
  {
    id: 'fried-egg-toast',
    name: 'Fried Egg on Toast',
    effort: 'one-pan',
    needs: ['egg', 'bread', 'butter'],
    optional: ['bacon', 'cheese', 'avocado'],
    description: 'Simple but satisfying breakfast',
    tips: 'Crispy edges, runny yolk is the goal'
  },
  {
    id: 'quesadilla',
    name: 'Quesadilla',
    effort: 'one-pan',
    needs: ['tortilla', 'cheese'],
    optional: ['chicken', 'beans', 'peppers', 'salsa'],
    description: 'Crispy cheese-filled tortilla',
    tips: 'Medium heat, flip when golden'
  },
  {
    id: 'grilled-cheese',
    name: 'Grilled Cheese Sandwich',
    effort: 'one-pan',
    needs: ['bread', 'cheese', 'butter'],
    optional: ['tomato', 'ham', 'bacon'],
    description: 'Buttery, melty perfection',
    tips: 'Low and slow for even melting'
  },
  {
    id: 'fried-rice',
    name: 'Fried Rice',
    effort: 'one-pan',
    needs: ['rice', 'egg', 'soy sauce'],
    optional: ['veg', 'chicken', 'peas', 'carrot'],
    description: 'Great for leftover rice',
    tips: 'Day-old cold rice works best'
  },
  {
    id: 'pasta-jar-sauce',
    name: 'Pasta with Jar Sauce',
    effort: 'one-pan',
    needs: ['pasta', 'pasta sauce'],
    optional: ['cheese', 'meat', 'veg'],
    description: 'Reliable dinner, always works',
    tips: 'Save pasta water to loosen sauce'
  },
  {
    id: 'ramen-upgrade',
    name: 'Upgraded Instant Ramen',
    effort: 'one-pan',
    needs: ['ramen', 'egg'],
    optional: ['green onion', 'sesame oil', 'veg'],
    description: 'Instant noodles made better',
    tips: 'Soft boil egg separately, add at end'
  },
  {
    id: 'pancakes',
    name: 'Pancakes',
    effort: 'one-pan',
    needs: ['flour', 'egg', 'milk'],
    optional: ['butter', 'maple syrup', 'berries'],
    description: 'Weekend breakfast classic',
    tips: 'Flip when bubbles form on surface'
  },
  {
    id: 'french-toast',
    name: 'French Toast',
    effort: 'one-pan',
    needs: ['bread', 'egg', 'milk'],
    optional: ['cinnamon', 'vanilla', 'maple syrup'],
    description: 'Eggy bread, sweet and filling',
    tips: 'Stale bread soaks better'
  },
  {
    id: 'stir-fry-simple',
    name: 'Simple Stir Fry',
    effort: 'one-pan',
    needs: ['veg', 'soy sauce', 'oil'],
    optional: ['chicken', 'tofu', 'garlic', 'ginger'],
    description: 'Quick veg, high heat',
    tips: 'Cut everything same size for even cooking'
  },
  {
    id: 'bacon-eggs',
    name: 'Bacon & Eggs',
    effort: 'one-pan',
    needs: ['bacon', 'egg'],
    optional: ['toast', 'tomato', 'beans'],
    description: 'Classic fry-up basics',
    tips: 'Start bacon in cold pan'
  },
  {
    id: 'tuna-melt',
    name: 'Tuna Melt',
    effort: 'one-pan',
    needs: ['bread', 'tuna', 'cheese'],
    optional: ['mayo', 'onion', 'tomato'],
    description: 'Hot sandwich with melty cheese',
    tips: 'Mix tuna with mayo before assembling'
  },
  {
    id: 'egg-fried-noodles',
    name: 'Egg Fried Noodles',
    effort: 'one-pan',
    needs: ['noodles', 'egg', 'soy sauce'],
    optional: ['veg', 'sesame oil', 'green onion'],
    description: 'Fast Asian-style comfort food',
    tips: 'Push noodles aside, scramble egg, then mix'
  },
  {
    id: 'hash-browns',
    name: 'Hash Browns',
    effort: 'one-pan',
    needs: ['potato', 'oil'],
    optional: ['onion', 'egg', 'cheese'],
    description: 'Crispy potato goodness',
    tips: 'Squeeze out moisture for crispiness'
  },
  {
    id: 'sausage-peppers',
    name: 'Sausage & Peppers',
    effort: 'one-pan',
    needs: ['sausage', 'peppers', 'onion'],
    optional: ['garlic', 'tomato', 'herbs'],
    description: 'Hearty one-pan dinner',
    tips: 'Brown sausage first, then add veg'
  },
  {
    id: 'shakshuka-simple',
    name: 'Simple Shakshuka',
    effort: 'one-pan',
    needs: ['egg', 'tomato', 'onion'],
    optional: ['garlic', 'spices', 'feta', 'bread'],
    description: 'Eggs poached in tomato sauce',
    tips: 'Create wells for eggs, cover to set'
  },
  {
    id: 'garlic-butter-shrimp',
    name: 'Garlic Butter Shrimp',
    effort: 'one-pan',
    needs: ['shrimp', 'butter', 'garlic'],
    optional: ['lemon', 'parsley', 'pasta'],
    description: 'Restaurant quality, 10 minutes',
    tips: 'Don\'t overcook - pink and curled means done'
  },
  {
    id: 'beans-on-toast',
    name: 'Beans on Toast',
    effort: 'one-pan',
    needs: ['beans', 'bread'],
    optional: ['cheese', 'egg', 'worcestershire'],
    description: 'British comfort classic',
    tips: 'Grate cheese on top while hot'
  },
  {
    id: 'mac-cheese-quick',
    name: 'Quick Mac & Cheese',
    effort: 'one-pan',
    needs: ['pasta', 'cheese', 'milk', 'butter'],
    optional: ['mustard', 'bacon', 'breadcrumbs'],
    description: 'Stovetop mac, no baking needed',
    tips: 'Stir constantly when adding cheese'
  },
  // === ADDITIONAL PROTEIN OPTIONS ===
  {
    id: 'chicken-quesadilla',
    name: 'Chicken Quesadilla',
    effort: 'one-pan',
    needs: ['tortilla', 'rotisserie chicken', 'cheese'],
    optional: ['peppers', 'onion', 'salsa', 'sour cream'],
    description: 'Loaded quesadilla with chicken',
    tips: 'Use leftover or rotisserie chicken'
  },
  {
    id: 'pork-fried-rice',
    name: 'Pork Fried Rice',
    effort: 'one-pan',
    needs: ['rice', 'pork', 'egg', 'soy sauce'],
    optional: ['veg', 'green onion', 'sesame oil'],
    description: 'Quick fried rice with pork',
    tips: 'Cut pork small for fast cooking'
  },
  {
    id: 'lamb-pitta',
    name: 'Lamb Pitta',
    effort: 'one-pan',
    needs: ['pitta', 'lamb', 'onion'],
    optional: ['yogurt', 'cucumber', 'tomato', 'herbs'],
    description: 'Quick spiced lamb in pitta bread',
    tips: 'Season lamb with cumin and paprika'
  },
  {
    id: 'turkey-stir-fry',
    name: 'Turkey Stir Fry',
    effort: 'one-pan',
    needs: ['turkey', 'veg', 'soy sauce'],
    optional: ['garlic', 'ginger', 'rice'],
    description: 'Lean protein stir fry',
    tips: 'Slice turkey thin for quick cooking'
  },
  {
    id: 'tofu-scramble',
    name: 'Tofu Scramble',
    effort: 'one-pan',
    needs: ['tofu', 'oil', 'onion'],
    optional: ['peppers', 'spinach', 'turmeric', 'toast'],
    description: 'Vegan egg scramble alternative',
    tips: 'Crumble tofu with hands for texture'
  },
  {
    id: 'veggie-fried-rice',
    name: 'Veggie Fried Rice',
    effort: 'one-pan',
    needs: ['rice', 'egg', 'veg', 'soy sauce'],
    optional: ['green onion', 'sesame oil', 'garlic'],
    description: 'Vegetarian fried rice',
    tips: 'Use whatever veg you have'
  },
  {
    id: 'fish-tacos-quick',
    name: 'Quick Fish Tacos',
    effort: 'one-pan',
    needs: ['white fish', 'tortilla', 'oil'],
    optional: ['cabbage', 'lime', 'salsa', 'sour cream'],
    description: 'Pan-fried fish in soft tacos',
    tips: 'Season fish with cumin and chili'
  }
];

export default ONE_PAN_RECIPES;
